<template>
  <div class>
    <header-vue></header-vue>
    <div class="container-l2">
      <h1 class="h11">角色管理</h1>
      <div class="text-right">
        <button class="btn btn-primary" @click="showAdd()">
          <i class="fa fa-plus"></i> 添加角色
        </button>
      </div>
      <div class="groupList">
        <!-- 点击角色头像修改名称，单击用户名称修改权限 -->
        <div class="sgroupList" v-for="(item,index) in roleList" :key="index">
          <i class="fa fa-user-circle-o" @click="showRole(item)"></i>
          <span v-text="item.role_name" @click="showDetailDialog(item)"></span>

          <strong class="fr">></strong>
          <span class="delete" @click="showDelete(item)">×</span>
        </div>
      </div>
    </div>
    <el-dialog title="角色更名" :visible.sync="roleDial" width="500px">
      <el-form label-width="80px">
        <el-form-item label="角色名称">
          <el-input v-model="roleMsg.role_name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="roleMsg.is_enable">
            <el-radio label="Y">可用</el-radio>
            <el-radio label="N">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelChangeName()">取消</el-button>
        <el-button type="primary" v-if="!ifAdd" @click="confirmModRole()">确定</el-button>
        <el-button type="primary" v-if="ifAdd" @click="confirmAddRole()">添加</el-button>
      </div>
    </el-dialog>
    <!--移除提示框-->
    <el-dialog title="提示框" :visible.sync="removeFlag" width="500px">
      <div class="userInfo">
        <h4>确认移除角色：{{roleMsg.role_name}} 吗？</h4>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="removeFlag = false">取消</el-button>
        <el-button type="primary" @click="confirmRemove()">确认</el-button>
      </div>
    </el-dialog>
    <!-- 详情弹框 -->
    <el-dialog :title="roleMsg.role_name+'所有菜单'" :visible.sync="detailFlag" width="700px">
      <el-form label-width="80px">
          <div class="check-block" v-for="(item, indexkey) in menu" :key="item.id">
            <template>
              <!-- 第一层菜单 -->
              <el-checkbox style="font-weight: 600;margin-bottom: 15px " v-model='menusIds' :label="item.id" @change='handleCheck(1,indexkey)'>
                {{item.name}}{{item.link}}
              </el-checkbox>
              <div>
                <div v-for="(list,listIndex) in item.children" :class="['line-check','clearfix',{'check-block':list.children.length}]" :key="list.id" >
                  <!-- 第二层菜单 -->
                  <el-checkbox @change='handleCheck(2,indexkey,listIndex)' v-model="menusIds" :label="list.id">
                    <i v-if="list.type==2" class="fa fa-circle"></i>
                    {{list.name}}
                  </el-checkbox>
                  <div class="{'check-block':list.children.length}">
                    <div v-for="(thirdlist,thirdIndex) in list.children" class="line-check clearfix" :key="thirdlist.id">
                      <!-- 第三层菜单 -->
                      <el-checkbox @change='handleCheck(3,indexkey,listIndex,thirdIndex)' v-model="menusIds" :label="thirdlist.id">
                        <i v-if="thirdlist.type==2" class="fa fa-circle"></i>
                        {{thirdlist.name}}
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailFlag=false">取消</el-button>
        <el-button type="primary" @click="changeDetail()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      roleList: [],
      roleMsg: {
        role_name: "",
        is_enable: ""
      },
      roleDial: false,
      ifAdd: false,
      removeFlag: false,
      detailFlag: false,
      roleDetail: [],
      roleNums: new Array(),
      checkFlag:true,
      activeInt:-1,
      allColumn:[],
      menu: [],
      menusIds: []
    };
  },
  
  mounted() {
    this.$nextTick(function() {
      this.getRoleList();
      this.getAllMenu();
    });
  },

  methods: {
    getRoleList() {
      this.showLoading = true;
      let roleListParams = {
        uid: this.getCookie("uid"),
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(roleListParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Role/rolelist",
          this.$qs.stringify(roleListParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.roleList = res.data.data || [];
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
          }
        });
    },
    // 处理选择事件
      handleCheck(type, a = 0, b=0, c=0) { // 多选框  a为一级菜单index，b是二级菜单index，c是三级菜单index
        let self = this;
        if (type == 3) { // 三级级菜单点击          
          let secondRow = self.menu[a].children[b]; 
          let checkId = self.menu[a].children[b].children[c].id || -1;        
          // 判断选中还是取消选中，如果选中，需要将上级菜单也选中
          if (self.menusIds.indexOf(checkId) > -1) {
            if (self.menusIds.indexOf(self.menu[a].id) < 0) {
              self.menusIds.push(self.menu[a].id); 
            }
            if(self.menusIds.indexOf(secondRow.id) < 0){
              self.menusIds.push(secondRow.id);
            }            
          } 
        }
        else if (type == 2) { // 二级菜单点击
          let secondRow = self.menu[a].children[b];       
          // 判断选中还是取消选中，如果选中，需要将上级菜单也选中
          if (self.menusIds.indexOf(secondRow.id) > -1) {                  
            if (self.menusIds.indexOf(self.menu[a].id) < 0) {
              self.menusIds.push(self.menu[a].id); 
            }
            if(secondRow.children.length){
              secondRow.children.map(sitem=>{
                if (self.menusIds.findIndex((n) => n == sitem.id) < 0) {                  
                  self.menusIds.push(sitem.id)
                }
               
              })
            }            
          }
          // 取消选中，二级对应三级菜单全部取消选中
          else{
            secondRow.children.map(sitem => {
              if (self.menusIds.findIndex((n) => n == sitem.id) > -1) {
                self.menusIds.splice(self.menusIds.findIndex((n) => n == sitem.id), 1);
              }
            })
          }
          
        } else {      //  一级菜单点击
          if (self.menusIds.indexOf(self.menu[a].id) > -1) {
            self.menu[a].children.map(item => {
              if (self.menusIds.findIndex((n) => n == item.id) < 0) {
                self.menusIds.push(item.id)
                item.children.map(sitem => {
                  if (self.menusIds.findIndex((n) => n == sitem.id) < 0) {
                    self.menusIds.push(sitem.id)
                  }
                })
              }
            })
          } else {
            self.menu[a].children.map(item => {
              if (self.menusIds.findIndex((n) => n == item.id) > -1) {
                self.menusIds.splice(self.menusIds.findIndex((n) => n == item.id), 1);
                item.children.map(sitem => {
                  if (self.menusIds.findIndex((n) => n == sitem.id) > -1) {
                    self.menusIds.splice(self.menusIds.findIndex((n) => n == sitem.id), 1);
                  }
                })
              }
            })
          }

        }
      },
      //编辑某个菜单
      handleEdit(obj) {
        let self = this;
        self.obj = obj;
        let array = obj.menuIds ? obj.menuIds.split(',') : []
        let arr = [];
        array.map(item => {
          arr.push(parseInt(item));
        })
        this.menusIds = arr;
      },
      // 获取所有菜单列表
      async _allMenuApi() {
        let res = await fetchRights();
        if (res.code == 200) {
          this.menu = res.data.allMenus;
        }
      },
    showRole(item) {
      this.roleMsg = item;
      this.roleDial = true;
      this.ifAdd = false;
    },
    showAdd() {
      this.roleMsg = {
        role_name: "",
        is_enable: ""
      },
      this.ifAdd = true;
      this.roleDial = true;
    },
    cancelChangeName() {
      this.roleDial = false;
    },
    confirmAddRole() {
      let addRoleParams = {
        uid: this.getCookie("uid"),
        role_name: this.roleMsg.role_name,
        is_enable: this.roleMsg.is_enable,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(addRoleParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Role/addrole",
          this.$qs.stringify(addRoleParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.roleDial = false;
            this.getRoleList();

            this.$message.success(res.data.msg);
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    },
    // 修改菜单明细
    changeDetail(){
      
     let detailParams = {
        uid: this.getCookie("uid"),
        role_id:this.roleMsg.id,
        action_ids:this.menusIds.toString(),
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(detailParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/RoleAction/updateroleaction",
          this.$qs.stringify(detailParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.detailFlag = false;
            this.$message.success(res.data.msg);
            
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    },
    confirmRemove() {
      let addRoleParams = {
        uid: this.getCookie("uid"),
        id: this.roleMsg.id,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(addRoleParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Role/delrole",
          this.$qs.stringify(addRoleParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.removeFlag = false;
            this.getRoleList();

            this.$message.success(res.data.msg);
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    },
    showDelete(item) {
      this.roleMsg = item;
      this.removeFlag = true;
    },
    // 调取数据后，角色可用菜单处理成数字
    formatNum(detail){      
      this.menusIds = new Array();
      let self = this;
      pushNum(detail)      
      function pushNum(detail){
        if (detail.length) {
          let i;
          for (i = 0; i < detail.length; i++) {
            self.menusIds.push(detail[i].id);
            let detail2 = detail[i].children || [];
            if(detail2.length){
              pushNum(detail2)
            }              
          }
        }
      } 
    },
   showDetailDialog(item) {
      this.roleMsg = item;
      this.detailFlag = true;
      
      
      let detailParams = {
        uid: this.getCookie("uid"),
        role_id:item.id,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(detailParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/RoleAction/roleaction",
          this.$qs.stringify(detailParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.roleDetail = res.data.data || [];
            
            this.formatNum(this.roleDetail);
            
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    },
    getAllMenu() {
      let self = this;
      let getAllMenuParams = {
        uid: this.getCookie("uid"),
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(getAllMenuParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Action/ablemenus",
          this.$qs.stringify(getAllMenuParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            self.menu = res.data.data || [];
                      
            
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    },
    confirmModRole() {
      let confirmModRoleParams = {
        uid: this.getCookie("uid"),
        id: this.roleMsg.id,
        role_name: this.roleMsg.role_name,
        is_enable: this.roleMsg.is_enable,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(confirmModRoleParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Role/revrole",
          this.$qs.stringify(confirmModRoleParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.roleDial = false;
            this.getRoleList();

            this.$message.success(res.data.msg);
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/rightPanel/roleManage.vue